<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Pénzügy</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <!-- A belső fülek az access-táblából jönnek (Jogosultságok szerkesztő):
           mindenki csak azt látja, amire a jogköre engedélyt kapott. -->
      <ion-col *ngIf="lathatoFulek.length > 1">
        <div id="content1">
          <div id="menu" class="row" style="text-align: center;">
            <ion-button *ngFor="let f of lathatoFulek" [color]="menu != f.menu ? 'light' : 'primary'"
              (click)="menuChange(f.menu)" style="min-width: 100px;">
              <div class="custom-button-content">
                <img [src]="f.ikon" width="50px">
                <span>{{ f.cim }}<br>
                  <select name="nezet" style="visibility: hidden;">
                    <option value="0">-</option>
                  </select>
                </span>
              </div>
            </ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!--ion-card color="primary" class="ion-color ion-color-primary md hydrated" *ngIf="loginmode=='gondviselo'">
      <ion-card-header class="ion-inherit-color md hydrated">
        <ion-card-title class="ion-inherit-color md hydrated">
          <ion-icon name="alert-circle-outline" class="md hydrated"></ion-icon>
          <span *ngIf="egyenleg.egyenleg == -1">Nincs felhasználható egyenleg</span>
          <span *ngIf="egyenleg.egyenleg != -1">Egyenleg: {{egyenleg.egyenleg}} Ft</span>
        </ion-card-title>
        <ion-card-subtitle class="ion-inherit-color md hydrated">

        </ion-card-subtitle>
      </ion-card-header>
    </ion-card-->
  

    <router-outlet></router-outlet>




  </ion-grid>

</ion-content>